import BaseService from "./BaseService";

class MasterDataService extends BaseService {
  constructor(prefix, method) {
    super(prefix, method);
  }
}

export default new MasterDataService('master-datas', BaseService.METHOD_GET);